import './ErrorMessage.css';

export default function ErrorMessage({ message = 'Une erreur est survenue', onRetry }) {
  return (
    <div className="error-message" role="alert">
      <p className="error-message__text chiron-goround-tc-body">{message}</p>
      {onRetry && (
        <button className="error-message__retry staatliches-regular" onClick={onRetry}>
          Réessayer
        </button>
      )}
    </div>
  );
}
